import swiper from "swiper";

var slider2 = new swiper(".js-hero-swiper", {
  slidesPerView: "auto",
  loop: false,
  speed: 1500,
  autoplay: {
    delay: 4500,
    disableOnInteraction: false,
  },
  effect: "fade",
  fade: {
    crossFade: true,
  },
});

const Swiper = new swiper(".js-topics-swiper", {
  loop: true,
  slidesPerView: 1,
  loopAdditionalSlides: 6,
  centeredSlides: true,
  allowTouchMove: false,
  speed: 12000,
  autoplay: {
    delay: 0,
  },
});

